import { Injectable } from '@angular/core';
import type { GridStorageState } from '../types/storage.type';

/**
 * 로컬스토리지에 그리드 상태를 저장하고 불러오는 서비스
 */
@Injectable({ providedIn: 'root' })
export class GridStorageService {
  /**
   * 상태를 로컬스토리지에 저장합니다
   */
  public saveState(key: string, state: GridStorageState): void {
    try {
      localStorage.setItem(key, JSON.stringify(state));
    } catch (error) {
      console.warn('Failed to save grid state to localStorage:', error);
    }
  }

  /**
   * 로컬스토리지에서 상태를 불러옵니다
   */
  public loadState(key: string): GridStorageState | null {
    try {
      const stored = localStorage.getItem(key);
      return stored ? JSON.parse(stored) : null;
    } catch (error) {
      console.warn('Failed to load grid state from localStorage:', error);
      return null;
    }
  }

  /**
   * 로컬스토리지에서 상태를 삭제합니다
   */
  public clearState(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.warn('Failed to clear grid state from localStorage:', error);
    }
  }
}
